/** Legacy live yield endpoints can take 60s+ due to ISIN/RBI processing. */
export const YIELD_API_TIMEOUT_MS = 120000;

/** Snapshot curve reads persisted risk_base_pricing (fast). */
export const YIELD_CURVE_SNAPSHOT_TIMEOUT_MS = 30000;

/**
 * Unwrap ApiResponseDTO { statusCode, message, data } or legacy flat/array payload.
 */
export function unwrapYieldPayload(response) {
  const body = response?.data;
  if (!body) {
    return null;
  }
  if (body.data != null && typeof body.data === "object" && !Array.isArray(body.data)) {
    return body.data;
  }
  return body;
}

export async function fetchYieldPayload(apiClient, url, timeoutMs = YIELD_API_TIMEOUT_MS) {
  const response = await apiClient.get(url, { timeout: timeoutMs });
  return unwrapYieldPayload(response);
}

/** G-Sec / SDL yield curve from risk_base_pricing snapshot ({@code GET /yield/curve-snapshot/{tradeType}}). */
export function buildYieldCurveSnapshotUrl(baseUrl, tradeType) {
  const root = (baseUrl || "").replace(/\/$/, "");
  const type = encodeURIComponent(tradeType);
  return `${root}/yield/curve-snapshot/${type}`;
}

export async function fetchYieldCurveSnapshot(apiClient, baseUrl, tradeType) {
  const url = buildYieldCurveSnapshotUrl(baseUrl, tradeType);
  return fetchYieldPayload(apiClient, url, YIELD_CURVE_SNAPSHOT_TIMEOUT_MS);
}
